import type { Action } from '../action'
import { ResourceType } from '../resource-type'

/** Agents, knowledge bases, API keys, integrations and usage reports */
export const ADMIN_TOOL_ACTIONS = {
  'admin:agent:configure': {
    description: "Change an agent's settings",
    resourceTypes: [ResourceType.Agent],
  },
  'admin:agent:deploy': {
    description: 'Deploy an agent to a zone, so grants can reach it there',
    resourceTypes: [ResourceType.Agent],
  },
  'admin:knowledge-base:read': {
    description: "List and download an agent's knowledge base files",
    resourceTypes: [ResourceType.Agent],
  },
  'admin:knowledge-base:write': {
    description: "Upload and delete an agent's knowledge base files",
    resourceTypes: [ResourceType.Agent],
  },
  'admin:api-key:create': {
    description: 'Create an API key that calls the REST API as oneself',
    resourceTypes: [ResourceType.Zone],
  },
  'admin:integration:read': {
    description: 'View integration connectors and their definitions',
    resourceTypes: [ResourceType.Zone],
  },
  'admin:integration:write': {
    description: 'Create, edit and delete integration connectors and definitions',
    resourceTypes: [ResourceType.Zone],
  },
  'admin:integration:run': {
    description: 'Run an integration connector',
    resourceTypes: [ResourceType.Zone],
  },
  'admin:usage:read': {
    description: 'View agent usage reports',
    resourceTypes: [ResourceType.Tenant],
  },
} as const satisfies Record<string, Action.Definition>
